/**
 * @author DjordjeV
 */
import { transform as olTransform } from 'ol/proj';
import { saveAs } from 'file-saver';
import { SimpleGeometry } from 'ol/geom';
import Feature from "ol/Feature";

export const GeofenceKmlExport = {
    export: (features: Feature, filename: string, color: string) => {
        const coordsNE: Coordinate[][] = (features.getGeometry() as SimpleGeometry).getCoordinates();

        const drawing = coordsNE.map(outline => {
                return outline.map(point => olTransform(point, 'EPSG:3857', 'EPSG:4326'));
            });
// NOTE: outline is black, 0.9 alpha, width 2; if we change const stylesStroke in geofence-features.ts, also change: <LineStyle> here
        const kml =
`<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    ${`<name>${filename}</name>`}
    <Style id="normal-style">
      <LineStyle>
        <color>e6000000</color>
        <width>2</width>
      </LineStyle>
      <PolyStyle>
        ${`<color>${color}</color>`}
        <fill>1</fill>
        <outline>1</outline>
      </PolyStyle>
      <BalloonStyle>
        <text><![CDATA[<h3>$[name]</h3>]]></text>
      </BalloonStyle>
    </Style>
    <StyleMap id="style-map">
      <Pair>
        <key>normal</key>
        <styleUrl>#normal-style</styleUrl>
      </Pair>
    </StyleMap>
    ${`<Placemark>
          <name>${filename}</name>
          <styleUrl>#style-map</styleUrl>
          <Polygon>
            <outerBoundaryIs>
              <LinearRing>
                <coordinates>
                  ${drawing.map(coords => {
                     return coords.map(pair => pair.join(',') + `,0`).join('\n');
                  })}
                </coordinates>
              </LinearRing>
            </outerBoundaryIs>
          </Polygon>
        </Placemark>`
    }
  </Document>
</kml>`;

        const file = new Blob([kml], { type: 'text/kml;charset=utf-8' });
        saveAs(file, `${filename}.kml`);
    }
};
